<template>
  <p class="font-quote text-quote-md sm:text-quote-lg text-primary-350">
    <slot />
  </p>
</template>
